import React, { useContext, useEffect, useState } from "react";
import MessageContainer from "./MessageContainer";
import { PAGE_STATE } from "../../../constants";
import useWorks from "../../../hooks/useWorks";
import ChatSessionContext from "../../../contexts/ChatSessionContext";
import AppContext from "../../../AppContext";
import { useNavigate } from "react-router-dom";
const assetsUri = import.meta.env.ASSETS_URI;

const _prefix = "chat-impression";

export const Impression = ({ workId, isOwner }) => {
  const { currentSession } = useContext(ChatSessionContext);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [work, setWork] = useState(undefined);
  const { getWork } = useWorks();
  const navigate = useNavigate();

  useEffect(() => {
    if (!workId) return;

    getWork(workId).then((data) => {
      setWork(data);
      setPageState(PAGE_STATE.IDLE);
    });
  }, [workId]);

  const handleClick = () => {
    navigate(`/work-exchanges/${workId}`);
  };

  if (pageState !== PAGE_STATE.IDLE) {
    return <></>;
  }

  console.log("currentSession.endUser", currentSession.endUser);

  const visitorName = currentSession.endUser.isCompany
    ? currentSession.endUser.name
    : currentSession.endUser.firstname;

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix} onClick={handleClick}>
        <img
          className={`${_prefix}-banner`}
          src={`${assetsUri}/${work.banner}`}
        />
        <div className={`${_prefix}-desc`}>
          <span>{isOwner ? visitorName : "You"} had visited</span>
          <span className={`${_prefix}-desc__name`}>{work.name}</span>
        </div>
      </div>
    </MessageContainer>
  );
};
